var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.file,{tag:"component",attrs:{"role":"img","focusable":"false","aria-label":_vm.alt,"fill":"currentColor"}})}
var staticRenderFns = []

export { render, staticRenderFns }